@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(1_912_333_514)
internal val Res.string.active_tables: StringResource by lazy {
      StringResource("string:active_tables", "active_tables", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62, 41),
      ))
    }

@delegate:ResourceContentHash(1_083_942_426)
internal val Res.string.active_tables_empty: StringResource by lazy {
      StringResource("string:active_tables_empty", "active_tables_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 51),
      ))
    }

@delegate:ResourceContentHash(-424_863_344)
internal val Res.string.add_image: StringResource by lazy {
      StringResource("string:add_image", "add_image", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104, 29),
      ))
    }

@delegate:ResourceContentHash(-914_668_826)
internal val Res.string.add_premade: StringResource by lazy {
      StringResource("string:add_premade", "add_premade", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134, 39),
      ))
    }

@delegate:ResourceContentHash(-1_414_993_658)
internal val Res.string.add_sound: StringResource by lazy {
      StringResource("string:add_sound", "add_sound", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174, 29),
      ))
    }

@delegate:ResourceContentHash(39_988_817)
internal val Res.string.alert_gm_dismiss: StringResource by lazy {
      StringResource("string:alert_gm_dismiss", "alert_gm_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 40),
      ))
    }

@delegate:ResourceContentHash(1_914_977_858)
internal val Res.string.alert_gm_inappropriate: StringResource by lazy {
      StringResource("string:alert_gm_inappropriate", "alert_gm_inappropriate", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 273, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245, 190),
      ))
    }

@delegate:ResourceContentHash(-1_893_136_713)
internal val Res.string.alert_gm_player_message: StringResource by lazy {
      StringResource("string:alert_gm_player_message", "alert_gm_player_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 472, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 436, 67),
      ))
    }

@delegate:ResourceContentHash(-1_520_459_558)
internal val Res.string.alert_gm_report_confirm: StringResource by lazy {
      StringResource("string:alert_gm_report_confirm", "alert_gm_report_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 544, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 504, 55),
      ))
    }

@delegate:ResourceContentHash(1_447_768_422)
internal val Res.string.alert_gm_report_eject_hint: StringResource by lazy {
      StringResource("string:alert_gm_report_eject_hint", "alert_gm_report_eject_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 604, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 560, 182),
      ))
    }

@delegate:ResourceContentHash(-843_642_810)
internal val Res.string.alert_gm_report_manyverse_hint: StringResource by lazy {
      StringResource("string:alert_gm_report_manyverse_hint", "alert_gm_report_manyverse_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 799, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 743, 158),
      ))
    }

@delegate:ResourceContentHash(822_570_271)
internal val Res.string.alert_gm_report_title: StringResource by lazy {
      StringResource("string:alert_gm_report_title", "alert_gm_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 970, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 53),
      ))
    }

@delegate:ResourceContentHash(-1_335_803_228)
internal val Res.string.alert_gm_uncomfortable: StringResource by lazy {
      StringResource("string:alert_gm_uncomfortable", "alert_gm_uncomfortable", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1028, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 956, 166),
      ))
    }

@delegate:ResourceContentHash(100_483_422)
internal val Res.string.alert_inappropriate: StringResource by lazy {
      StringResource("string:alert_inappropriate", "alert_inappropriate", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1344, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1264, 75),
      ))
    }

@delegate:ResourceContentHash(1_997_584_643)
internal val Res.string.alert_inappropriate_info: StringResource by lazy {
      StringResource("string:alert_inappropriate_info", "alert_inappropriate_info", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1203, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1123, 140),
      ))
    }

@delegate:ResourceContentHash(614_429_788)
internal val Res.string.alert_message_hint: StringResource by lazy {
      StringResource("string:alert_message_hint", "alert_message_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1420, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1340, 70),
      ))
    }

@delegate:ResourceContentHash(-1_784_030_747)
internal val Res.string.alert_sent_confirmation: StringResource by lazy {
      StringResource("string:alert_sent_confirmation", "alert_sent_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1495, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1411, 67),
      ))
    }

@delegate:ResourceContentHash(-1_425_159_797)
internal val Res.string.alert_uncomfortable: StringResource by lazy {
      StringResource("string:alert_uncomfortable", "alert_uncomfortable", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1700, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1588, 87),
      ))
    }

@delegate:ResourceContentHash(1_726_570_949)
internal val Res.string.alert_uncomfortable_info: StringResource by lazy {
      StringResource("string:alert_uncomfortable_info", "alert_uncomfortable_info", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1575, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1479, 108),
      ))
    }

@delegate:ResourceContentHash(197_629_329)
internal val Res.string.announcement_active_announcements: StringResource by lazy {
      StringResource("string:announcement_active_announcements", "announcement_active_announcements", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1792, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1676, 69),
      ))
    }

@delegate:ResourceContentHash(-1_104_597_620)
internal val Res.string.announcement_cancel: StringResource by lazy {
      StringResource("string:announcement_cancel", "announcement_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1858, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1746, 51),
      ))
    }

@delegate:ResourceContentHash(1_893_355_082)
internal val Res.string.announcement_image: StringResource by lazy {
      StringResource("string:announcement_image", "announcement_image", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1981, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1861, 50),
      ))
    }

@delegate:ResourceContentHash(1_048_189_331)
internal val Res.string.announcement_image_description: StringResource by lazy {
      StringResource("string:announcement_image_description", "announcement_image_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1918, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1798, 62),
      ))
    }

@delegate:ResourceContentHash(1_881_648_419)
internal val Res.string.announcement_in_progress: StringResource by lazy {
      StringResource("string:announcement_in_progress", "announcement_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2032, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1912, 48),
      ))
    }

@delegate:ResourceContentHash(-885_758_578)
internal val Res.string.announcement_launched_at: StringResource by lazy {
      StringResource("string:announcement_launched_at", "announcement_launched_at", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2077, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1961, 56),
      ))
    }

@delegate:ResourceContentHash(6_918_816)
internal val Res.string.announcement_text: StringResource by lazy {
      StringResource("string:announcement_text", "announcement_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2193, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2077, 37),
      ))
    }

@delegate:ResourceContentHash(1_992_758_560)
internal val Res.string.announcement_text_hint: StringResource by lazy {
      StringResource("string:announcement_text_hint", "announcement_text_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2130, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2018, 58),
      ))
    }

@delegate:ResourceContentHash(-1_669_172_754)
internal val Res.string.announcement_title: StringResource by lazy {
      StringResource("string:announcement_title", "announcement_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2231, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2115, 50),
      ))
    }

@delegate:ResourceContentHash(516_625_044)
internal val Res.string.announcement_validation_error: StringResource by lazy {
      StringResource("string:announcement_validation_error", "announcement_validation_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2282, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2166, 77),
      ))
    }

@delegate:ResourceContentHash(1_199_618_949)
internal val Res.string.anonymous_sign_in_continue: StringResource by lazy {
      StringResource("string:anonymous_sign_in_continue", "anonymous_sign_in_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2352, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2244, 46),
      ))
    }

@delegate:ResourceContentHash(-373_991_639)
internal val Res.string.anonymous_sign_in_warning_message: StringResource by lazy {
      StringResource("string:anonymous_sign_in_warning_message", "anonymous_sign_in_warning_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2399, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2291, 177),
      ))
    }

@delegate:ResourceContentHash(1_940_503_947)
internal val Res.string.anonymous_sign_in_warning_title: StringResource by lazy {
      StringResource("string:anonymous_sign_in_warning_title", "anonymous_sign_in_warning_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2601, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2469, 63),
      ))
    }

@delegate:ResourceContentHash(1_984_124_093)
internal val Res.string.app_logo: StringResource by lazy {
      StringResource("string:app_logo", "app_logo", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2665, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2533, 36),
      ))
    }

@delegate:ResourceContentHash(-75_880_021)
internal val Res.string.auto_play_active: StringResource by lazy {
      StringResource("string:auto_play_active", "auto_play_active", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2702, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2570, 84),
      ))
    }

@delegate:ResourceContentHash(1_947_483_696)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2803, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2655, 20),
      ))
    }

@delegate:ResourceContentHash(18_713_781)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2824, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2676, 22),
      ))
    }

@delegate:ResourceContentHash(892_064_011)
internal val Res.string.character: StringResource by lazy {
      StringResource("string:character", "character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5230, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4870, 29),
      ))
    }

@delegate:ResourceContentHash(1_608_503_482)
internal val Res.string.character_avatar: StringResource by lazy {
      StringResource("string:character_avatar", "character_avatar", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2851, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2699, 44),
      ))
    }

@delegate:ResourceContentHash(1_171_903_092)
internal val Res.string.character_count: StringResource by lazy {
      StringResource("string:character_count", "character_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2896, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2744, 47),
      ))
    }

@delegate:ResourceContentHash(1_645_040_928)
internal val Res.string.character_informations: StringResource by lazy {
      StringResource("string:character_informations", "character_informations", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2944, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2792, 46),
      ))
    }

@delegate:ResourceContentHash(-1_690_495_832)
internal val Res.string.character_mode_free: StringResource by lazy {
      StringResource("string:character_mode_free", "character_mode_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2991, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2839, 51),
      ))
    }

@delegate:ResourceContentHash(961_921_323)
internal val Res.string.character_mode_template: StringResource by lazy {
      StringResource("string:character_mode_template", "character_mode_template", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3198, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3034, 51),
      ))
    }

@delegate:ResourceContentHash(1_973_388_182)
internal val Res.string.character_mode_template_coming_soon: StringResource by lazy {
      StringResource("string:character_mode_template_coming_soon", "character_mode_template_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3043, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2891, 83),
      ))
    }

@delegate:ResourceContentHash(1_824_200_128)
internal val Res.string.character_mode_template_dropdown_label: StringResource by lazy {
      StringResource("string:character_mode_template_dropdown_label", "character_mode_template_dropdown_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3139, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2975, 58),
      ))
    }

@delegate:ResourceContentHash(515_644_842)
internal val Res.string.character_name: StringResource by lazy {
      StringResource("string:character_name", "character_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3322, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3142, 30),
      ))
    }

@delegate:ResourceContentHash(-153_227_974)
internal val Res.string.character_name_hint: StringResource by lazy {
      StringResource("string:character_name_hint", "character_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3258, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3086, 55),
      ))
    }

@delegate:ResourceContentHash(582_138_433)
internal val Res.string.character_sheet_add: StringResource by lazy {
      StringResource("string:character_sheet_add", "character_sheet_add", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3614, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3394, 31),
      ))
    }

@delegate:ResourceContentHash(-564_727_275)
internal val Res.string.character_sheet_add_characteristic: StringResource by lazy {
      StringResource("string:character_sheet_add_characteristic", "character_sheet_add_characteristic", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3349, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3173, 70),
      ))
    }

@delegate:ResourceContentHash(793_133_023)
internal val Res.string.character_sheet_add_gauge: StringResource by lazy {
      StringResource("string:character_sheet_add_gauge", "character_sheet_add_gauge", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3432, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3244, 49),
      ))
    }

@delegate:ResourceContentHash(-1_952_280_806)
internal val Res.string.character_sheet_add_power: StringResource by lazy {
      StringResource("string:character_sheet_add_power", "character_sheet_add_power", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3490, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3294, 49),
      ))
    }

@delegate:ResourceContentHash(677_529_255)
internal val Res.string.character_sheet_add_skill: StringResource by lazy {
      StringResource("string:character_sheet_add_skill", "character_sheet_add_skill", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3548, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3344, 49),
      ))
    }

@delegate:ResourceContentHash(515_644_842)
internal val Res.string.character_sheet_characteristic_name: StringResource by lazy {
      StringResource("string:character_sheet_characteristic_name", "character_sheet_characteristic_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3654, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3426, 51),
      ))
    }

@delegate:ResourceContentHash(869_227_578)
internal val Res.string.character_sheet_characteristic_value: StringResource by lazy {
      StringResource("string:character_sheet_characteristic_value", "character_sheet_characteristic_value", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3702, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3478, 52),
      ))
    }

@delegate:ResourceContentHash(-942_596_729)
internal val Res.string.character_sheet_characteristics_section: StringResource by lazy {
      StringResource("string:character_sheet_characteristics_section", "character_sheet_characteristics_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3755, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3531, 67),
      ))
    }

@delegate:ResourceContentHash(1_964_797_320)
internal val Res.string.character_sheet_delete_entry: StringResource by lazy {
      StringResource("string:character_sheet_delete_entry", "character_sheet_delete_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3827, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3599, 44),
      ))
    }

@delegate:ResourceContentHash(1_188_383_333)
internal val Res.string.character_sheet_done: StringResource by lazy {
      StringResource("string:character_sheet_done", "character_sheet_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3876, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3644, 36),
      ))
    }

@delegate:ResourceContentHash(734_113_899)
internal val Res.string.character_sheet_edit: StringResource by lazy {
      StringResource("string:character_sheet_edit", "character_sheet_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3917, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3681, 56),
      ))
    }

@delegate:ResourceContentHash(-11_725_206)
internal val Res.string.character_sheet_empty: StringResource by lazy {
      StringResource("string:character_sheet_empty", "character_sheet_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3986, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3738, 105),
      ))
    }

@delegate:ResourceContentHash(-1_687_754_358)
internal val Res.string.character_sheet_entry_description: StringResource by lazy {
      StringResource("string:character_sheet_entry_description", "character_sheet_entry_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4132, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3844, 73),
      ))
    }

@delegate:ResourceContentHash(1_155_002_854)
internal val Res.string.character_sheet_fix_errors: StringResource by lazy {
      StringResource("string:character_sheet_fix_errors", "character_sheet_fix_errors", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4206, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3918, 82),
      ))
    }

@delegate:ResourceContentHash(744_282_514)
internal val Res.string.character_sheet_gauge_color: StringResource by lazy {
      StringResource("string:character_sheet_gauge_color", "character_sheet_gauge_color", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4354, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4062, 43),
      ))
    }

@delegate:ResourceContentHash(-1_616_876_330)
internal val Res.string.character_sheet_gauge_color_pick: StringResource by lazy {
      StringResource("string:character_sheet_gauge_color_pick", "character_sheet_gauge_color_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4285, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4001, 60),
      ))
    }

@delegate:ResourceContentHash(82_824_736)
internal val Res.string.character_sheet_gauge_end: StringResource by lazy {
      StringResource("string:character_sheet_gauge_end", "character_sheet_gauge_end", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4402, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4106, 37),
      ))
    }

@delegate:ResourceContentHash(-1_340_367_781)
internal val Res.string.character_sheet_gauge_increment: StringResource by lazy {
      StringResource("string:character_sheet_gauge_increment", "character_sheet_gauge_increment", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4440, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4144, 47),
      ))
    }

@delegate:ResourceContentHash(858_308_044)
internal val Res.string.character_sheet_gauge_initial: StringResource by lazy {
      StringResource("string:character_sheet_gauge_initial", "character_sheet_gauge_initial", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4496, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4192, 93),
      ))
    }

@delegate:ResourceContentHash(515_644_842)
internal val Res.string.character_sheet_gauge_name: StringResource by lazy {
      StringResource("string:character_sheet_gauge_name", "character_sheet_gauge_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4598, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4286, 42),
      ))
    }

@delegate:ResourceContentHash(82_864_512)
internal val Res.string.character_sheet_gauge_start: StringResource by lazy {
      StringResource("string:character_sheet_gauge_start", "character_sheet_gauge_start", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4637, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4329, 39),
      ))
    }

@delegate:ResourceContentHash(840_265_542)
internal val Res.string.character_sheet_gauges_section: StringResource by lazy {
      StringResource("string:character_sheet_gauges_section", "character_sheet_gauges_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4677, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4369, 46),
      ))
    }

@delegate:ResourceContentHash(2_084_321_776)
internal val Res.string.character_sheet_power_label: StringResource by lazy {
      StringResource("string:character_sheet_power_label", "character_sheet_power_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4724, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4416, 43),
      ))
    }

@delegate:ResourceContentHash(2_084_545_781)
internal val Res.string.character_sheet_powers_section: StringResource by lazy {
      StringResource("string:character_sheet_powers_section", "character_sheet_powers_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4772, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4460, 46),
      ))
    }

@delegate:ResourceContentHash(-563_996_888)
internal val Res.string.character_sheet_show_less: StringResource by lazy {
      StringResource("string:character_sheet_show_less", "character_sheet_show_less", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4823, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4507, 45),
      ))
    }

@delegate:ResourceContentHash(393_841_490)
internal val Res.string.character_sheet_show_more: StringResource by lazy {
      StringResource("string:character_sheet_show_more", "character_sheet_show_more", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4873, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4553, 45),
      ))
    }

@delegate:ResourceContentHash(966_194_010)
internal val Res.string.character_sheet_skill_label: StringResource by lazy {
      StringResource("string:character_sheet_skill_label", "character_sheet_skill_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4919, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4599, 43),
      ))
    }

@delegate:ResourceContentHash(966_196_954)
internal val Res.string.character_sheet_skills_section: StringResource by lazy {
      StringResource("string:character_sheet_skills_section", "character_sheet_skills_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4971, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4643, 46),
      ))
    }

@delegate:ResourceContentHash(-942_596_729)
internal val Res.string.character_sheet_tab: StringResource by lazy {
      StringResource("string:character_sheet_tab", "character_sheet_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5026, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4690, 47),
      ))
    }

@delegate:ResourceContentHash(-1_834_053_199)
internal val Res.string.character_story: StringResource by lazy {
      StringResource("string:character_story", "character_story", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5159, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4803, 31),
      ))
    }

@delegate:ResourceContentHash(389_201_995)
internal val Res.string.character_story_hint: StringResource by lazy {
      StringResource("string:character_story_hint", "character_story_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5078, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4738, 64),
      ))
    }

@delegate:ResourceContentHash(72_740_936)
internal val Res.string.characters: StringResource by lazy {
      StringResource("string:characters", "characters", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5195, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4835, 34),
      ))
    }

@delegate:ResourceContentHash(-1_797_154_613)
internal val Res.string.choose_existing_character: StringResource by lazy {
      StringResource("string:choose_existing_character", "choose_existing_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5264, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4900, 69),
      ))
    }

@delegate:ResourceContentHash(-122_996_073)
internal val Res.string.choose_premade: StringResource by lazy {
      StringResource("string:choose_premade", "choose_premade", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5338, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4970, 46),
      ))
    }

@delegate:ResourceContentHash(-1_855_923_112)
internal val Res.string.clear_search: StringResource by lazy {
      StringResource("string:clear_search", "clear_search", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5389, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5017, 36),
      ))
    }

@delegate:ResourceContentHash(1_490_337_184)
internal val Res.string.close_announcement: StringResource by lazy {
      StringResource("string:close_announcement", "close_announcement", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5438, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5054, 34),
      ))
    }

@delegate:ResourceContentHash(486_879_910)
internal val Res.string.collapse: StringResource by lazy {
      StringResource("string:collapse", "collapse", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5473, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5089, 28),
      ))
    }

@delegate:ResourceContentHash(582_138_433)
internal val Res.string.combat_add: StringResource by lazy {
      StringResource("string:combat_add", "combat_add", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5612, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5220, 22),
      ))
    }

@delegate:ResourceContentHash(-245_881_777)
internal val Res.string.combat_add_adversary: StringResource by lazy {
      StringResource("string:combat_add_adversary", "combat_add_adversary", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5502, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5118, 52),
      ))
    }

@delegate:ResourceContentHash(1_202_562_472)
internal val Res.string.combat_add_to_combat: StringResource by lazy {
      StringResource("string:combat_add_to_combat", "combat_add_to_combat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5559, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5171, 48),
      ))
    }

@delegate:ResourceContentHash(2_104_867_976)
internal val Res.string.combat_adversary_label: StringResource by lazy {
      StringResource("string:combat_adversary_label", "combat_adversary_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5643, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5243, 42),
      ))
    }

@delegate:ResourceContentHash(762_533_069)
internal val Res.string.combat_adversary_name_hint: StringResource by lazy {
      StringResource("string:combat_adversary_name_hint", "combat_adversary_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5690, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5286, 58),
      ))
    }

@delegate:ResourceContentHash(1_049_569_925)
internal val Res.string.combat_bubble_description: StringResource by lazy {
      StringResource("string:combat_bubble_description", "combat_bubble_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5749, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5345, 57),
      ))
    }

@delegate:ResourceContentHash(1_811_137_023)
internal val Res.string.combat_bubble_double_tap_hint: StringResource by lazy {
      StringResource("string:combat_bubble_double_tap_hint", "combat_bubble_double_tap_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5803, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5403, 129),
      ))
    }

@delegate:ResourceContentHash(1_749_375_465)
internal val Res.string.combat_current_turn: StringResource by lazy {
      StringResource("string:combat_current_turn", "combat_current_turn", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5949, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5533, 43),
      ))
    }

@delegate:ResourceContentHash(390_672_147)
internal val Res.string.combat_drag_handle: StringResource by lazy {
      StringResource("string:combat_drag_handle", "combat_drag_handle", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5993, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5577, 46),
      ))
    }

@delegate:ResourceContentHash(152_788_136)
internal val Res.string.combat_end_turn: StringResource by lazy {
      StringResource("string:combat_end_turn", "combat_end_turn", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6052, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5624, 35),
      ))
    }

@delegate:ResourceContentHash(1_995_138_142)
internal val Res.string.combat_in_combat: StringResource by lazy {
      StringResource("string:combat_in_combat", "combat_in_combat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6100, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5660, 36),
      ))
    }

@delegate:ResourceContentHash(-1_153_771_635)
internal val Res.string.combat_its_turn: StringResource by lazy {
      StringResource("string:combat_its_turn", "combat_its_turn", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6137, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5697, 43),
      ))
    }

@delegate:ResourceContentHash(1_392_022_925)
internal val Res.string.combat_launch: StringResource by lazy {
      StringResource("string:combat_launch", "combat_launch", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6181, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5741, 29),
      ))
    }

@delegate:ResourceContentHash(-45_073_192)
internal val Res.string.combat_minimize: StringResource by lazy {
      StringResource("string:combat_minimize", "combat_minimize", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6211, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5771, 35),
      ))
    }

@delegate:ResourceContentHash(-64_606_657)
internal val Res.string.combat_move_down: StringResource by lazy {
      StringResource("string:combat_move_down", "combat_move_down", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6247, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5807, 36),
      ))
    }

@delegate:ResourceContentHash(563_205_853)
internal val Res.string.combat_move_up: StringResource by lazy {
      StringResource("string:combat_move_up", "combat_move_up", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6284, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5844, 34),
      ))
    }

@delegate:ResourceContentHash(-522_261_940)
internal val Res.string.combat_order_empty: StringResource by lazy {
      StringResource("string:combat_order_empty", "combat_order_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6315, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5879, 74),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("active_tables", Res.string.active_tables)
  map.put("active_tables_empty", Res.string.active_tables_empty)
  map.put("add_image", Res.string.add_image)
  map.put("add_premade", Res.string.add_premade)
  map.put("add_sound", Res.string.add_sound)
  map.put("alert_gm_dismiss", Res.string.alert_gm_dismiss)
  map.put("alert_gm_inappropriate", Res.string.alert_gm_inappropriate)
  map.put("alert_gm_player_message", Res.string.alert_gm_player_message)
  map.put("alert_gm_report_confirm", Res.string.alert_gm_report_confirm)
  map.put("alert_gm_report_eject_hint", Res.string.alert_gm_report_eject_hint)
  map.put("alert_gm_report_manyverse_hint", Res.string.alert_gm_report_manyverse_hint)
  map.put("alert_gm_report_title", Res.string.alert_gm_report_title)
  map.put("alert_gm_uncomfortable", Res.string.alert_gm_uncomfortable)
  map.put("alert_inappropriate", Res.string.alert_inappropriate)
  map.put("alert_inappropriate_info", Res.string.alert_inappropriate_info)
  map.put("alert_message_hint", Res.string.alert_message_hint)
  map.put("alert_sent_confirmation", Res.string.alert_sent_confirmation)
  map.put("alert_uncomfortable", Res.string.alert_uncomfortable)
  map.put("alert_uncomfortable_info", Res.string.alert_uncomfortable_info)
  map.put("announcement_active_announcements", Res.string.announcement_active_announcements)
  map.put("announcement_cancel", Res.string.announcement_cancel)
  map.put("announcement_image", Res.string.announcement_image)
  map.put("announcement_image_description", Res.string.announcement_image_description)
  map.put("announcement_in_progress", Res.string.announcement_in_progress)
  map.put("announcement_launched_at", Res.string.announcement_launched_at)
  map.put("announcement_text", Res.string.announcement_text)
  map.put("announcement_text_hint", Res.string.announcement_text_hint)
  map.put("announcement_title", Res.string.announcement_title)
  map.put("announcement_validation_error", Res.string.announcement_validation_error)
  map.put("anonymous_sign_in_continue", Res.string.anonymous_sign_in_continue)
  map.put("anonymous_sign_in_warning_message", Res.string.anonymous_sign_in_warning_message)
  map.put("anonymous_sign_in_warning_title", Res.string.anonymous_sign_in_warning_title)
  map.put("app_logo", Res.string.app_logo)
  map.put("auto_play_active", Res.string.auto_play_active)
  map.put("back", Res.string.back)
  map.put("cancel", Res.string.cancel)
  map.put("character", Res.string.character)
  map.put("character_avatar", Res.string.character_avatar)
  map.put("character_count", Res.string.character_count)
  map.put("character_informations", Res.string.character_informations)
  map.put("character_mode_free", Res.string.character_mode_free)
  map.put("character_mode_template", Res.string.character_mode_template)
  map.put("character_mode_template_coming_soon", Res.string.character_mode_template_coming_soon)
  map.put("character_mode_template_dropdown_label", Res.string.character_mode_template_dropdown_label)
  map.put("character_name", Res.string.character_name)
  map.put("character_name_hint", Res.string.character_name_hint)
  map.put("character_sheet_add", Res.string.character_sheet_add)
  map.put("character_sheet_add_characteristic", Res.string.character_sheet_add_characteristic)
  map.put("character_sheet_add_gauge", Res.string.character_sheet_add_gauge)
  map.put("character_sheet_add_power", Res.string.character_sheet_add_power)
  map.put("character_sheet_add_skill", Res.string.character_sheet_add_skill)
  map.put("character_sheet_characteristic_name", Res.string.character_sheet_characteristic_name)
  map.put("character_sheet_characteristic_value", Res.string.character_sheet_characteristic_value)
  map.put("character_sheet_characteristics_section", Res.string.character_sheet_characteristics_section)
  map.put("character_sheet_delete_entry", Res.string.character_sheet_delete_entry)
  map.put("character_sheet_done", Res.string.character_sheet_done)
  map.put("character_sheet_edit", Res.string.character_sheet_edit)
  map.put("character_sheet_empty", Res.string.character_sheet_empty)
  map.put("character_sheet_entry_description", Res.string.character_sheet_entry_description)
  map.put("character_sheet_fix_errors", Res.string.character_sheet_fix_errors)
  map.put("character_sheet_gauge_color", Res.string.character_sheet_gauge_color)
  map.put("character_sheet_gauge_color_pick", Res.string.character_sheet_gauge_color_pick)
  map.put("character_sheet_gauge_end", Res.string.character_sheet_gauge_end)
  map.put("character_sheet_gauge_increment", Res.string.character_sheet_gauge_increment)
  map.put("character_sheet_gauge_initial", Res.string.character_sheet_gauge_initial)
  map.put("character_sheet_gauge_name", Res.string.character_sheet_gauge_name)
  map.put("character_sheet_gauge_start", Res.string.character_sheet_gauge_start)
  map.put("character_sheet_gauges_section", Res.string.character_sheet_gauges_section)
  map.put("character_sheet_power_label", Res.string.character_sheet_power_label)
  map.put("character_sheet_powers_section", Res.string.character_sheet_powers_section)
  map.put("character_sheet_show_less", Res.string.character_sheet_show_less)
  map.put("character_sheet_show_more", Res.string.character_sheet_show_more)
  map.put("character_sheet_skill_label", Res.string.character_sheet_skill_label)
  map.put("character_sheet_skills_section", Res.string.character_sheet_skills_section)
  map.put("character_sheet_tab", Res.string.character_sheet_tab)
  map.put("character_story", Res.string.character_story)
  map.put("character_story_hint", Res.string.character_story_hint)
  map.put("characters", Res.string.characters)
  map.put("choose_existing_character", Res.string.choose_existing_character)
  map.put("choose_premade", Res.string.choose_premade)
  map.put("clear_search", Res.string.clear_search)
  map.put("close_announcement", Res.string.close_announcement)
  map.put("collapse", Res.string.collapse)
  map.put("combat_add", Res.string.combat_add)
  map.put("combat_add_adversary", Res.string.combat_add_adversary)
  map.put("combat_add_to_combat", Res.string.combat_add_to_combat)
  map.put("combat_adversary_label", Res.string.combat_adversary_label)
  map.put("combat_adversary_name_hint", Res.string.combat_adversary_name_hint)
  map.put("combat_bubble_description", Res.string.combat_bubble_description)
  map.put("combat_bubble_double_tap_hint", Res.string.combat_bubble_double_tap_hint)
  map.put("combat_current_turn", Res.string.combat_current_turn)
  map.put("combat_drag_handle", Res.string.combat_drag_handle)
  map.put("combat_end_turn", Res.string.combat_end_turn)
  map.put("combat_in_combat", Res.string.combat_in_combat)
  map.put("combat_its_turn", Res.string.combat_its_turn)
  map.put("combat_launch", Res.string.combat_launch)
  map.put("combat_minimize", Res.string.combat_minimize)
  map.put("combat_move_down", Res.string.combat_move_down)
  map.put("combat_move_up", Res.string.combat_move_up)
  map.put("combat_order_empty", Res.string.combat_order_empty)
}
